export const environment = {
  production: true,
  connection: {
    name: 'LH Klagenfurt Softline',
    host: 'https://softline.lwg.at/',
    port: 443,
    // host: 'http://devsrv01',
    // port: 8118,
    basePath: '/api'
  },
  theme: '',
  androidUpdateRepository: ''
};
